export default "__VITE_ASSET__ChoyX5OZ__"